import Badge from '@mui/material/Badge';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

const OnboardingStepsList = ({ currentStep }: { currentStep?: number }) => {
  return (
    <Grid
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 1,
      }}
    >
      <Grid>
        <Badge
          sx={{ paddingLeft: '0.75rem' }}
          badgeContent="1"
          color={
            currentStep
              ? currentStep === 1
                ? 'primary'
                : 'warning'
              : 'secondary'
          }
        />
        <Typography variant={'subtitle1'} sx={{ paddingLeft: '1.5rem' }}>
          Company details
        </Typography>
      </Grid>
      <Grid>
        <Badge
          badgeContent="2"
          sx={{ paddingLeft: '0.75rem' }}
          color={
            currentStep
              ? currentStep === 2
                ? 'primary'
                : 'warning'
              : 'secondary'
          }
        />
        <Typography variant={'subtitle1'} sx={{ paddingLeft: '1.5rem' }}>
          Personal details
        </Typography>
      </Grid>
      <Grid>
        <Badge
          sx={{ paddingLeft: '0.75rem' }}
          badgeContent="3"
          color={
            currentStep
              ? currentStep === 3
                ? 'primary'
                : 'warning'
              : 'secondary'
          }
        />
        <Typography variant={'subtitle1'} sx={{ paddingLeft: '1.5rem' }}>
          Invite team
        </Typography>
      </Grid>
    </Grid>
  );
};

export default OnboardingStepsList;
